import HookNameEnum from '~/enums/widgets/HookNameEnum'

import QuIcon1 from 'assets/icons/QuoteCategories/icon-qu-1.png'
import QuIcon2 from 'assets/icons/QuoteCategories/icon-qu-2.png'
import QuIcon3 from 'assets/icons/QuoteCategories/icon-qu-3.png'
import QuIcon4 from 'assets/icons/QuoteCategories/icon-qu-4.png'
import QuIcon5 from 'assets/icons/QuoteCategories/icon-qu-5.png'
import QuIcon6 from 'assets/icons/QuoteCategories/icon-qu-6.png'

interface QuoteCategory {
  hook: string
  icon: string
}

interface QuoteCategories {
  [key: string]: QuoteCategory
}

const quoteCategories: QuoteCategories = {
  'all-stores': {
    hook: HookNameEnum.QuotesAllStoresLandingPage,
    icon: QuIcon1,
  },
  'clothes-and-accessories-stores': {
    hook: HookNameEnum.QuotesClothesAndAccessoriesStoresLandingPage,
    icon: QuIcon3,
  },
  'beauty-products-stores': {
    hook: HookNameEnum.QuotesBeautyProductsStoresLandingPage,
    icon: QuIcon4,
  },
  'food-supplements-stores': {
    hook: HookNameEnum.QuotesFoodSupplementsStoresLandingPage,
    icon: QuIcon5,
  },
  'auto-moto-parts-stores': {
    hook: HookNameEnum.QuotesAutoMotoPartsStoresLandingPage,
    icon: QuIcon6,
  },
}

export default quoteCategories
